import { TemplateType } from 'compobot-dynamic-page';
import { UseFormSetValue } from 'react-hook-form';
import {
  CompobotGuiVersionType,
  CreateGuiVersionType,
} from 'types/compobotGuiVersion.type';

export const populateFormFromData = (
  data: CompobotGuiVersionType,
  setValue: UseFormSetValue<CreateGuiVersionType>,
  setColors: React.Dispatch<
    React.SetStateAction<{
      pretext: string;
      title: string;
      subtitle: string;
      overlay: string;
    }>
  >,
  setWordCounts: {
    setPretextEnCount: React.Dispatch<React.SetStateAction<number>>;
    setPretextHuCount: React.Dispatch<React.SetStateAction<number>>;
    setTitleEnCount: React.Dispatch<React.SetStateAction<number>>;
    setTitleHuCount: React.Dispatch<React.SetStateAction<number>>;
    setSubtitleEnCount: React.Dispatch<React.SetStateAction<number>>;
    setSubtitleHuCount: React.Dispatch<React.SetStateAction<number>>;
  },
) => {
  const guiConfig = data.jsonGuiDescriptor.GUIConfiguration;

  // Set form values
  setValue('guiName', data.name || '');
  setValue('description', data.description || '');
  setValue('compobotName', guiConfig.customParams.compobot_name || '');
  setValue('language', guiConfig.app.defaultLanguage || 'en');
  setValue('logoPath', guiConfig.customParams.logo || '');
  setValue(
    'backgroundImage',
    guiConfig.customParams.dynamicPage.backgroundImageSrc || '',
  );
  setValue('qrCodeEn', guiConfig.customParams.dynamicPage.qr.en || '');
  setValue('qrCodeHu', guiConfig.customParams.dynamicPage.qr.hu || '');
  setValue('pretextEn', guiConfig.customParams.dynamicPage.pretext.en || '');
  setValue('pretextHu', guiConfig.customParams.dynamicPage.pretext.hu || '');
  setValue('titleEn', guiConfig.customParams.dynamicPage.title.en || '');
  setValue('titleHu', guiConfig.customParams.dynamicPage.title.hu || '');
  setValue('subtitleEn', guiConfig.customParams.dynamicPage.subtitle.en || '');
  setValue('subtitleHu', guiConfig.customParams.dynamicPage.subtitle.hu || '');
  setValue('from', guiConfig.customParams.dynamicPage.display_date.from || '');
  setValue('to', guiConfig.customParams.dynamicPage.display_date.to || '');
  setValue(
    'templateType',
    guiConfig.customParams.dynamicPage.template_type || TemplateType.THEME_01,
  );

  // Update colors
  setColors({
    pretext: guiConfig.customParams.dynamicPage.pretext.color || '#2a6fe7ff',
    title: guiConfig.customParams.dynamicPage.title.color || '#40d622ff',
    subtitle: guiConfig.customParams.dynamicPage.subtitle.color || '#bd2a2aff',
    overlay: guiConfig.customParams.dynamicPage.overlay_color || '#3cb784',
  });

  // Update word counts
  const {
    setPretextEnCount,
    setPretextHuCount,
    setTitleEnCount,
    setTitleHuCount,
    setSubtitleEnCount,
    setSubtitleHuCount,
  } = setWordCounts;

  setPretextEnCount(guiConfig.customParams.dynamicPage.pretext.en?.length || 0);
  setPretextHuCount(guiConfig.customParams.dynamicPage.pretext.hu?.length || 0);
  setTitleEnCount(guiConfig.customParams.dynamicPage.title.en?.length || 0);
  setTitleHuCount(guiConfig.customParams.dynamicPage.title.hu?.length || 0);
  setSubtitleEnCount(
    guiConfig.customParams.dynamicPage.subtitle.en?.length || 0,
  );
  setSubtitleHuCount(
    guiConfig.customParams.dynamicPage.subtitle.hu?.length || 0,
  );
};
